import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F4F0] px-4" data-testid="payment-cancel">
      <Card className="max-w-md w-full bg-white border border-[#D1D1CD] rounded-lg shadow-sm">
        <CardContent className="p-8 text-center">
          <div className="w-20 h-20 rounded-full bg-[#D97706]/10 flex items-center justify-center mx-auto mb-4">
            <XCircle className="w-12 h-12 text-[#D97706]" />
          </div>
          <h1
            className="text-3xl font-bold text-[#1C1C1E]"
            style={{ fontFamily: 'Manrope, sans-serif' }}
          >
            Payment cancelled
          </h1>
          <p className="text-[#5C5C5C] mt-2 mb-6">
            No charges have been made. You can try again anytime.
          </p>
          <div className="space-y-2">
            <Button
              onClick={() => navigate('/pricing')}
              data-testid="back-to-pricing-btn"
              className="w-full h-12 bg-[#2E4632] hover:bg-[#1F3122] text-white font-semibold"
            >
              Back to Pricing
            </Button>
            <Button
              onClick={() => navigate('/dashboard')}
              variant="outline"
              className="w-full h-12 border-[#D1D1CD]"
            >
              Go to Dashboard
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancel;
